// CRM-LEADS-2026-10-16 §2: the lists refresh themselves, and what arrived since you last looked shows as a count.
//   * Every LIVE_MS while the CRM tab is visible (and at once when it becomes visible again) the leads and the agent
//     tables are re-read -- the Leads list, Needs a human and the open conversation follow without a reload.
//   * "New" = arrived after the last time this device opened that list (kept per device, localStorage). Opening the list
//     clears it. The browser tab's title carries the total, e.g. "(3) TherapyLink".
import { isSpamTagged } from './spamMark';
import { CANDIDATE_ROLES } from './conversationTriage';

export const LIVE_MS = 45000;
export const SEEN_KEY = 'crm.seen.v1';
export const LIVE_VIEWS = ['leads', 'needs', 'conversations'];

const t = (iso) => { const v = iso ? Date.parse(iso) : NaN; return Number.isNaN(v) ? null : v; };

/** The per-device "last opened" times; a first visit starts at `now` (nothing is "new" on a device's first day). */
export function readSeen(storage, now = Date.now()) {
  let saved = {};
  try { saved = JSON.parse((storage && storage.getItem(SEEN_KEY)) || '{}') || {}; } catch { saved = {}; }
  const out = {};
  for (const v of LIVE_VIEWS) out[v] = Number.isFinite(saved[v]) ? saved[v] : now;
  return out;
}
export function writeSeen(storage, seen) {
  try { if (storage) storage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch { /* private window: counts reset per visit */ }
}

/**
 * -> { leads, conversations, needs, total }: what arrived after each list was last opened.
 *   leads          new leads (spam-tagged ones never count)
 *   conversations  new inbound messages (a candidate's reply)
 *   needs          Needs-a-human rows whose latest reply is newer
 */
export function freshCounts({ leads = [], refs = [], needsHuman = [], seen }) {
  const s = seen || {};
  const leadsN = leads.filter((l) => l && !isSpamTagged(l) && (t(l.created_at) ?? 0) > (s.leads ?? Infinity)).length;
  const convN = refs.filter((m) => m && CANDIDATE_ROLES.has(String(m.role || '').toLowerCase()) && (t(m.created_at) ?? 0) > (s.conversations ?? Infinity)).length;
  const needsN = needsHuman.filter((r) => (t(r.lastReplyAt) ?? 0) > (s.needs ?? Infinity)).length;
  return { leads: leadsN, conversations: convN, needs: needsN, total: leadsN + convN + needsN };
}

/** "(3) TherapyLink" -- or the plain title when nothing is new. */
export function titleWith(base, total) {
  const clean = String(base || '').replace(/^\(\d+\)\s+/, '');
  return total > 0 ? `(${total}) ${clean}` : clean;
}

/** Re-read now? Visible tab, and the last read is at least `minGap` old (a tab coming back after a while reads at once). */
export function shouldRefresh({ visible, lastAt, now = Date.now(), minGap = 15000 }) {
  return !!visible && (!lastAt || now - lastAt >= minGap);
}
